// extracted by mini-css-extract-plugin
export var bold = "_rq-0";